import { ForwardedRef, forwardRef, useImperativeHandle, useRef, useState } from 'react';

import { Modal } from 'src/common/components';
import { ModalRefProps } from 'src/common/components/Modal';

interface DeleteCampaignModalProps {
  onAccept?: (id: any) => void;
}

export const DeleteCampaignModal = forwardRef(
  (
    { onAccept = (id) => {} }: DeleteCampaignModalProps,
    ref: ForwardedRef<ModalRefProps>
  ): JSX.Element => {
    const [canDelete, setCanDelete] = useState(true);
    const id = useRef<string | null>(null);
    const modalRef = useRef<ModalRefProps>(null);

    useImperativeHandle(ref, () => ({
      show: (value: string, deletable: boolean) => {
        setCanDelete(deletable);
        id.current = value;
        modalRef.current?.show();
      },
      hide: () => modalRef.current?.hide(),
    }));

    const handleRemove = async (): Promise<void> => {
      onAccept(id.current);
    };

    const message = canDelete
      ? 'Are you sure you wan to remove selected campaign details?'
      : 'The campaign details cannot be deleted, first disassociate the associated accounts';

    return (
      <Modal
        cancelText={canDelete ? 'Cancel' : 'Ok'}
        actionText="Accept"
        actionFunc={handleRemove}
        ref={modalRef}
        showAction={canDelete}
      >
        <div>
          <h3>Remove campaign details</h3>
          <div className="px-2 mt-4">{message}</div>
        </div>
      </Modal>
    );
  }
);
